/* Product Tabs section (sections/product-tabs.liquid)
   Collection tabs + Owl product carousel per tab, equal-height cards,
   swatch -> variant image swap. Depends on the theme's global jQuery + Owl. */
(function () {
  function initSection(root) {
    if (!window.jQuery || root.__hpTabsInit) return;
    root.__hpTabsInit = true;
    var $ = window.jQuery;
    var $root = $(root);
    var $panels = $root.find('.hp-tabs__panel');

    // Make every card in a carousel the same (tallest) height.
    function equalize($c) {
      var $cards = $c.find('.hp-card');
      if (!$cards.length) return;
      $cards.css('height', '');
      var max = 0;
      $cards.each(function () { if (this.offsetHeight > max) { max = this.offsetHeight; } });
      if (max) { $cards.css('height', max + 'px'); }
    }

    function initOwl($panel) {
      var $c = $panel.find('.hp-tabs__carousel');
      if (!$c.length) return;
      if ($c.data('hpOwlInit')) {
        $c.trigger('refresh.owl.carousel');
        equalize($c);
        return;
      }
      $c.data('hpOwlInit', true);
      var perView = parseInt($c.attr('data-items-desktop'), 10) || 4;
      $c.on('initialized.owl.carousel refreshed.owl.carousel resized.owl.carousel', function () {
        equalize($c);
      });
      $c.owlCarousel({
        margin: 16,
        nav: true,
        dots: true,
        navText: ['', ''],
        responsive: {
          0: { items: 1 },
          600: { items: 2 },
          1024: { items: perView }
        }
      });
    }

    // Initialise the active (visible) panel; hidden panels init lazily on show.
    initOwl($panels.filter('.is-active'));

    // Re-equalize the active carousel on resize (debounced).
    var rzTimer;
    $(window).on('resize.hpTabs', function () {
      clearTimeout(rzTimer);
      rzTimer = setTimeout(function () {
        var $c = $root.find('.hp-tabs__panel.is-active .hp-tabs__carousel');
        if ($c.data('hpOwlInit')) { equalize($c); }
      }, 200);
    });

    $root.on('click', '.hp-tabs__tab', function () {
      var idx = $(this).attr('data-tab');
      $root.find('.hp-tabs__tab').removeClass('is-active').attr('aria-selected', 'false');
      $(this).addClass('is-active').attr('aria-selected', 'true');
      $panels.removeClass('is-active');
      var $panel = $panels.filter('[data-panel="' + idx + '"]').addClass('is-active');
      initOwl($panel);
    });

    // Swatch click -> variant image swap lives in assets/card-swatches.js,
    // bound once at document level so it also works on the collection grid
    // and survives the innerHTML swap facets.js does on every filter change.
  }

  function initAll(ctx) {
    if (!window.jQuery) return;
    window.jQuery(ctx || document).find('.hp-tabs').each(function () { initSection(this); });
  }

  // Wait for jQuery (+ Owl plugin) which may load after this script.
  function whenReady(cb) {
    var tries = 0;
    (function poll() {
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.owlCarousel) { cb(); return; }
      if (tries++ < 150) { setTimeout(poll, 50); }
    })();
  }

  whenReady(function () { initAll(); });

  document.addEventListener('shopify:section:load', function (e) {
    whenReady(function () { initAll(e.target); });
  });
})();
